import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import AppLink from '../../../../components/AppLink';
import RelicAvatar from '../../../../components/RelicAvatar';

import { blue, } from '@mui/material/colors';

import Button from "@mui/material/Button";
import { Physician } from '../../../../models';
import { titleCase } from '../../../../helpers';
import { ROUTES } from '../../../../history';

const PhysicianView: React.FC<{
    physician: Physician;
    onClick: () => void;
    show?: boolean;
}> = ({
    physician,
    onClick,
    show = true,
}) => {
    
        return (
            <Box sx={{
            
                minWidth: '250px'
            }}>
                <Box display="flex" sx={{mb: 2}}>

                    <RelicAvatar size={60} display user={physician} avatarBgColor={ blue[500]} />

                    <div style={{paddingLeft: '1em'}}>
                        <Typography fontWeight={'bold'}>
                            Dr. {titleCase(`${physician.FirstName} ${physician.LastName}`)}
                        </Typography>
                        <Typography variant='subtitle1' color="#6B779A" sx={{mb: 1}} >
                            {physician.Email}
                        </Typography>
                        <Button variant="outlined" color={physician.isVerified ? 'error' : 'success'} sx={{
                            mr: 1
                        }}
                        onClick={
                            onClick
                        }
                        >
                      {physician.isVerified ? 'Deactivate' : 'Activate'}
                        </Button>
                 {show && (       <AppLink to={ROUTES.ADMIN_BASE + '/physicians/view/' + physician.id} >
                    View
                </AppLink>)}
                    </div>
                </Box>

                <div style={{
                    padding: '1em',
                    borderRadius: '24px',
                    border: '1px solid rgba(107, 119, 154, 0.1)'
                }}>
                    <Typography component="h6" variant="h6" fontWeight={'bold'}>
                        User Info
                    </Typography>
                    <Grid container spacing={1} style={{
                        marginBottom: '12px'
                    }}>
                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    LGA
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    {physician.LGA}
                                </Typography>
                            </div>
                        </Grid>

                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    Discipline
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    Physician
                                </Typography>
                            </div>
                        </Grid>


                        <Grid item xs={4} >
                            <div className="name-item">
                                <Typography variant='subtitle1'>
                                    Experience
                                </Typography>
                                <Typography fontWeight={'bold'}>
                                    {physician.Experience} years
                                </Typography>
                            </div>
                        </Grid>


                    </Grid>

                    <div style={{
                        padding: '1em',
                        borderRadius: '24px',
                        border: '1px solid rgba(107, 119, 154, 0.1)',
                        backgroundColor: '#F8F8FA'
                    }}>
                        <Typography fontWeight={'bold'}>
                            Bio
                        </Typography>

                        <Typography variant='subtitle1' color={'#6B779A'}>
                                    {physician.bio}
                                </Typography>
                    </div>

                </div>

            </Box>
        )
    }

export default PhysicianView